




















































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
export default defineComponent({
  name: 'BaseNotification',
  components: {
    BaseIcon,
    BaseButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'secondary',
      validator: function (value) {
        // @ts-ignore migrated from ui-library
        return ['secondary', 'info', 'success', 'warning', 'danger'].includes(value);
      },
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'added_to_cart';
        case 'danger':
          return 'info_shield';
        default:
          return 'info_circle';
      }
    },
    colorClass() {
      switch (this.type) {
        case 'secondary':
          return 'color-secondary';
        case 'info':
          return 'color-info';
        case 'success':
          return 'color-success';
        case 'warning':
          return 'color-warning';
        case 'danger':
          return 'color-danger';
        default:
          return 'color-info';
      }
    },
  },
  methods: {
    actionHandler() {
      this.$emit('click:action');
    },
    closeHandler() {
      this.$emit('click:close');
    },
  },
});
